import type { DashboardAnalytics, SeoAnalytics } from "@/domain/models/analytics";
import type { AnalyticsRepository } from "@/domain/repositories/analytics.repository";
import type { HttpClient } from "@/infrastructure/http/http-client";

export class HttpAnalyticsRepository implements AnalyticsRepository {
  constructor(private readonly http: HttpClient) {}

  getDashboard(): Promise<DashboardAnalytics> {
    return this.http.get<DashboardAnalytics>("/analytics/dashboard");
  }

  getSeo(): Promise<SeoAnalytics> {
    return this.http.get<SeoAnalytics>("/analytics/seo");
  }
}
